export default __webpack_public_path__ + "static/media/indiba_deep_beauty.a0ec3de1.jpeg";